import el from "@cypherpotato/el";
import dayjs from "dayjs";
import { Button } from "./button";
import { FormControl } from "./form";
import { MutedText } from "./text";
import { Icon } from "./icon";
import { showFlyout } from "../ui/flyout";

const dateTimeInputFormat = "YYYY-MM-DDTHH:mm";

export function RelativeTimeRange({ id, onPredefinedButtonClick, onInput }) {

    const range = el.state.create({
        start: dayjs().subtract(1, "week").toISOString(),
        end: dayjs().toISOString()
    });

    function updateRange(newRange, notify = true) {
        range.value = newRange;

        if (notify) {
            onInput?.(range.value);
        }
    }

    function setRange(amount, unit) {
        updateRange({
            start: dayjs()
                .subtract(amount, unit)
                .toISOString(),
            end: dayjs()
                .toISOString()
        });

        onPredefinedButtonClick?.();
    }

    function setRangeFrom(start) {
        updateRange({
            start: start.toISOString(),
            end: dayjs().toISOString()
        });

        onPredefinedButtonClick?.();
    }

    return el.state.listening([range], () =>
        el(
            ".relative-time-range-control[form-slot]",

            {
                id,
                $properties: {
                    value: {
                        get() {
                            return {
                                start: range.value.start,
                                end: range.value.end
                            };
                        },
                        set(newValue) {
                            updateRange(newValue, false);
                        }
                    }
                }
            },

            el(
                "div.relative-time-range-control__time-range",

                FormControl(
                    "From",
                    el("input.app-input[type=datetime-local]", {
                        value: dayjs(range.value.start).format(dateTimeInputFormat),
                        onChange(event) {
                            if (event.target.value) {
                                updateRange({
                                    ...range.value,
                                    start: dayjs(event.target.value).toISOString()
                                });
                            }
                        }
                    })
                ),

                MutedText(
                    Icon("arrow-right-line")
                ),

                FormControl(
                    "To",
                    el("input.app-input[type=datetime-local]", {
                        value: dayjs(range.value.end).format(dateTimeInputFormat),
                        onChange(event) {
                            if (event.target.value) {
                                updateRange({
                                    ...range.value,
                                    end: dayjs(event.target.value).toISOString()
                                });
                            }
                        }
                    })
                )
            ),

            el(
                "div.relative-time-range-control__button_list",

                Button("Today", {
                    onClick() {
                        setRangeFrom(dayjs().startOf("day"));
                    }
                }),

                Button("This week", {
                    onClick() {
                        setRangeFrom(dayjs().startOf("week"));
                    }
                }),

                Button("This month", {
                    onClick() {
                        setRangeFrom(dayjs().startOf("month"));
                    }
                }),

                el("hr"),

                Button("Past 30 minutes", {
                    onClick() {
                        setRange(30, "minute");
                    }
                }),

                Button("Past hour", {
                    onClick() {
                        setRange(1, "hour");
                    }
                }),

                Button("Past 3 hours", {
                    onClick() {
                        setRange(3, "hour");
                    }
                }),

                Button("Past day", {
                    onClick() {
                        setRange(24, "hour");
                    }
                }),

                Button("Past week", {
                    onClick() {
                        setRange(1, "week");
                    }
                }),

                Button("Past month", {
                    onClick() {
                        setRange(1, "month");
                    }
                }),

                Button("Past year", {
                    onClick() {
                        setRange(1, "year");
                    }
                })
            )
        )
    );
}

export function RelativeTimeRangePicker({ id, ...args }) {

    let currentFlyout = null;
    const state = el.state.create(null);

    const control = RelativeTimeRange({
        ...args,
        onInput(value) {
            state.value = value;
            args.onInput?.(value);
        },
        onPredefinedButtonClick() {
            currentFlyout?.dismiss();
        }
    });

    state.value = control.value;

    return el.state.listening([state], () =>
        Button(
            {
                id,
                $properties: {
                    value: {
                        get() {
                            return {
                                start: state.value.start,
                                end: state.value.end
                            };
                        },
                        set(newValue) {
                            control.value = newValue;
                            state.value = control.value;
                        }
                    }
                }
            },

            dayjs.duration(
                dayjs(state.value.end).diff(dayjs(state.value.start))
            ).humanize(),

            {
                onClick() {
                    showFlyout(control, {
                        init() {
                            currentFlyout = this;
                        }
                    });
                }
            }
        )
    );
}
